// YouTube helpers: extract the 11-char video id from various URL forms and
// build a thumbnail URL. Returns null when no id can be parsed.

export function getYouTubeId(url) {
   if (!url) return null;
   const match = url.match(/(?:embed\/|v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
   return match ? match[1] : null;
}

export function getThumbnailUrl(id) {
   return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}
